export const FEE_RATE = 0.0125;
export const SG_RATE = 0.12;

const BRACKETS = [
    { upTo: 18200, rate: 0, base: 0, floor: 0 },
    { upTo: 45000, rate: 0.16, base: 0, floor: 18200 },
    { upTo: 135000, rate: 0.3, base: 4288, floor: 45000 },
    { upTo: 190000, rate: 0.37, base: 31288, floor: 135000 },
    { upTo: Infinity, rate: 0.45, base: 51638, floor: 190000 },
];

export function annualTax(income) {
    if (income <= 0) return 0;
    let tax = 0;
    for (const b of BRACKETS) {
        if (income <= b.upTo) {
            tax = b.base + (income - b.floor) * b.rate;
            break;
        }
    }
    return tax + income * 0.02;
}

export function marginalRate(income) {
    for (const b of BRACKETS) {
        if (income <= b.upTo) return b.rate + 0.02;
    }
    return 0.47;
}

export const fmtAUD = (v) =>
    new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        maximumFractionDigits: 0,
    }).format(Math.round(v || 0));

export const CYCLE_HOURS = { weekly: 38, fortnightly: 76, monthly: 164 };

export function computePayslip({ rate, basis, cycle, sacrifice = 0 }) {
    const factor = cycle === "fortnightly" ? 2 : cycle === "monthly" ? 52 / 12 : 1;
    const gross =
        basis === "hour" ? rate * CYCLE_HOURS[cycle] : basis === "day" ? rate * 5 * factor : ((rate * 12) / 52) * factor;
    const fee = gross * FEE_RATE;
    const ncr = gross - fee;
    const superAmt = (ncr * SG_RATE) / (1 + SG_RATE);
    const sac = Math.max(0, Math.min(sacrifice, ncr - superAmt));
    const taxable = ncr - superAmt - sac;
    const periods = cycle === "fortnightly" ? 26 : cycle === "monthly" ? 12 : 52;
    const tax = annualTax(taxable * periods) / periods;
    const cash = taxable - tax;
    return { gross, fee, ncr, super: superAmt, sacrifice: sac, taxable, tax, cash, periods };
}

export function leaseEstimate({ price, income }) {
    const residual = price * 0.2813;
    const financed = price - residual;
    const monthly = (financed / 60) * 1.32 + 220;
    const annual = monthly * 12;
    const marginal = marginalRate(income);
    const taxSaved = annual * marginal;
    const effectiveWeekly = (annual - taxSaved) / 52;
    const evFriendly = price <= 91387;
    return { monthly, annual, taxSaved, effectiveWeekly, residual, marginal, evFriendly };
}
